{
  "categories": [
    {
      "id": "ai",
      "fill_color": "#FC5757",
      "stroke_color": "#A63633",
      "en": "Artificial Intelligence",
      "fr": "Intelligence Artificielle"
    },
    {
      "id": "cloud",
      "fill_color": "#035266",
      "stroke_color": "#014554",
      "en": "Cloud & Infrastructure",
      "fr": "Cloud & Infrastructure"
    },
    {
      "id": "data",
      "fill_color": "#00C0DB",
      "stroke_color": "#00A0B0",
      "en": "Data Platform",
      "fr": "Plateforme Data"
    },
    {
      "id": "nocode",
      "fill_color": "#FF91F0",
      "stroke_color": "#EB73DE",
      "en": "No-Code / Low-code",
      "fr": "No-Code / Low-code"
    },
    {
      "id": "language",
      "fill_color": "#5D74FD",
      "stroke_color": "#3E4FC2",
      "en": "Programming Languages",
      "fr": "Langages de Programmation"
    },
    {
      "id": "security",
      "fill_color": "#F0B021",
      "stroke_color": "#D29614",
      "en": "Cyber-Security",
      "fr": "Cyber-Sécurité"
    }
  ],
  "skills": [
    {
      "growth": 0.73,
      "volume": 6257.546,
      "skill": "WordPress",
      "display_name": "WordPress",
      "part": 1.180219620065135,
      "category": "nocode",
      "en": "WordPress is an open-source content management system (CMS) created by Automattic and the WordPress community. Launched in 2003, it powers a significant portion of the web, enabling users to build and manage websites and blogs with a focus on flexibility and user-friendliness through themes and plugins.",
      "fr": "WordPress est un système de gestion de contenu (CMS) open-source créé par Automattic et la communauté WordPress. Lancé en 2003, il alimente une part importante du web, permettant aux utilisateurs de créer et de gérer des sites web et des blogs en mettant l'accent sur la flexibilité et la convivialité grâce aux thèmes et aux plugins."
    },
    {
      "growth": 16.880000000000003,
      "volume": 2311.473,
      "skill": "n8n",
      "display_name": "n8n",
      "part": 0.4359609639067483,
      "category": "nocode",
      "en": "n8n is a low-code automation tool that allows users to connect various applications and automate workflows. Created by n8n.io, it is designed for simplifying complex integrations and repetitive tasks through a visual interface, enabling efficient process automation across different software systems.",
      "fr": "n8n est un outil d'automatisation low-code qui permet aux utilisateurs de connecter diverses applications et d'automatiser des workflows. Créé par n8n.io, il est conçu pour simplifier les intégrations complexes et les tâches répétitives grâce à une interface visuelle, permettant une automatisation efficace des processus entre différents systèmes logiciels."
    },
    {
      "growth": 0.62,
      "volume": 815.814,
      "skill": "flutterflow",
      "display_name": "flutterflow",
      "part": 0.15386857549649943,
      "category": "nocode",
      "en": "FlutterFlow is a low-code development platform that enables the creation of custom applications. It allows users to design, build, and launch applications for web and mobile using a visual interface, accelerating the development process for various business needs.",
      "fr": "FlutterFlow est une plateforme de développement low-code qui permet la création d'applications personnalisées. Elle permet aux utilisateurs de concevoir, construire et lancer des applications pour le web et le mobile en utilisant une interface visuelle, accélérant ainsi le processus de développement pour divers besoins commerciaux."
    },
    {
      "growth": 1.21,
      "volume": 728.14,
      "skill": "Make",
      "display_name": "Make",
      "part": 0.13733260836663883,
      "category": "nocode",
      "en": "Make.com (ex Integromat) is a low-code automation platform that enables users to visually create, build, and automate entire workflows. Developed by Celonis, it focuses on connecting thousands of apps through a drag-and-drop interface, allowing for sophisticated data manipulation and seamless process synchronization across diverse digital ecosystems without requiring extensive coding knowledge.",
      "fr": "Make.com est une plateforme d'automatisation low-code qui permet aux utilisateurs de concevoir, construire et automatiser visuellement des flux de travail complets. Développée par Celonis, elle se concentre sur la connexion de milliers d'applications via une interface glisser-déposer, permettant une manipulation de données complexe et une synchronisation fluide des processus entre divers écosystèmes numériques sans nécessiter de connaissances approfondies en programmation."
    },
    {
      "growth": 0.8200000000000001,
      "volume": 610.003,
      "skill": "Power Apps",
      "display_name": "Power Apps",
      "part": 0.11505109333572498,
      "category": "nocode",
      "en": "Microsoft Power Apps is a low-code platform that allows users to build custom business applications. Launched by Microsoft, it enables rapid development with a drag-and-drop interface, connecting to various data sources and streamlining business processes without extensive traditional coding.",
      "fr": "Microsoft Power Apps est une plateforme low-code qui permet aux utilisateurs de créer des applications métier personnalisées. Lancé par Microsoft, il permet un développement rapide avec une interface drag-and-drop, se connectant à diverses sources de données et rationalisant les processus métier sans codage traditionnel approfondi."
    },
    {
      "growth": 0.63,
      "volume": 573.596,
      "skill": "Bubble.io",
      "display_name": "Bubble.io",
      "part": 0.10818446291739305,
      "category": "nocode",
      "en": "Bubble.io is a visual programming platform that enables users to build web applications without writing code. Launched in 2012 by co-founders Josh Haas, Arnav Doshi, and Marco Troughton, it allows for the creation of complex workflows and database management, making it a powerful tool for rapid prototyping and full-scale application development.",
      "fr": "Bubble.io est une plateforme de programmation visuelle qui permet aux utilisateurs de créer des applications web sans écrire de code. Lancée en 2012 par les co-fondateurs Josh Haas, Arnav Doshi et Marco Troughton, elle permet la création de workflows complexes et la gestion de bases de données, en faisant un outil puissant pour le prototypage rapide et le développement d'applications à grande échelle."
    },
    {
      "growth": 1.54,
      "volume": 449.515,
      "skill": "Power Automate",
      "display_name": "Power Automate",
      "part": 0.0847818653692005,
      "category": "nocode",
      "en": "Microsoft Power Automate is a business process automation tool developed by Microsoft. Launched in 2016, it allows users to create automated workflows between their favorite apps and services to synchronize files, get notifications, collect data, and more, streamlining repetitive tasks.",
      "fr": "Microsoft Power Automate est un outil d'automatisation des processus métier développé par Microsoft. Lancé en 2016, il permet aux utilisateurs de créer des workflows automatisés entre leurs applications et services préférés pour synchroniser des fichiers, recevoir des notifications, collecter des données, et plus encore, en rationalisant les tâches répétitives."
    },
    {
      "growth": 0.97,
      "volume": 384.131,
      "skill": "Airtable",
      "display_name": "Airtable",
      "part": 0.07244995767913497,
      "category": "nocode",
      "en": "Airtable is a cloud-based collaboration service that combines the simplicity of a spreadsheet with the power of a database. Launched in 2012 by Howie Liu, Andrew Ofstad, and Emmett Nicholas, it allows users to organize, track, and manage projects and data through customizable views and integrations, serving fields from project management to CRM.",
      "fr": "Airtable est un service de collaboration basé sur le cloud qui combine la simplicité d'une feuille de calcul avec la puissance d'une base de données. Lancé en 2012 par Howie Liu, Andrew Ofstad et Emmett Nicholas, il permet aux utilisateurs d'organiser, de suivre et de gérer des projets et des données grâce à des vues et des intégrations personnalisables, servant des domaines allant de la gestion de projet au CRM."
    },
    {
      "growth": 1.3900000000000001,
      "volume": 378.93,
      "skill": "Webflow",
      "display_name": "Webflow",
      "part": 0.07146901047651612,
      "category": "nocode",
      "en": "Webflow is a visual website development tool that enables designers and developers to build professional, responsive websites without writing code. Launched in 2013, it empowers users with a powerful interface for creating custom designs and managing content, making it a popular choice for modern web development.",
      "fr": "Webflow est un outil de développement de sites web visuel qui permet aux designers et aux développeurs de créer des sites web professionnels et responsives sans écrire de code. Lancé en 2013, il offre aux utilisateurs une interface puissante pour créer des designs personnalisés et gérer du contenu, ce qui en fait un choix populaire pour le développement web moderne."
    },
    {
      "growth": 1.01,
      "volume": 144.885,
      "skill": "Google Apps Script",
      "display_name": "App Script",
      "part": 0.02732638635866793,
      "category": "nocode",
      "en": "Google Apps Script is a JavaScript-based scripting platform developed by Google. It allows users to extend Google Workspace applications like Docs, Sheets, and Forms, enabling automation of tasks and creation of custom solutions within the Google ecosystem. It was first released in 2009.",
      "fr": "Google Apps Script est une plateforme de scripting basée sur JavaScript développée par Google. Elle permet aux utilisateurs d'étendre les applications Google Workspace comme Docs, Sheets et Forms, permettant l'automatisation des tâches et la création de solutions personnalisées au sein de l'écosystème Google. Elle a été publiée pour la première fois en 2009."
    },
    {
      "growth": 0.75,
      "volume": 133.74,
      "skill": "xano",
      "display_name": "xano",
      "part": 0.025224356638770398,
      "category": "nocode",
      "en": "Xano is a no-code backend platform that allows developers to build scalable applications without writing traditional code. Launched in 2020, it provides a powerful, integrated environment for database management, API creation, and business logic automation, simplifying backend development for a wide range of web and mobile applications.",
      "fr": "Xano est une plateforme backend no-code qui permet aux développeurs de construire des applications scalables sans écrire de code traditionnel. Lancée en 2020, elle offre un environnement puissant et intégré pour la gestion de base de données, la création d'API et l'automatisation de la logique métier, simplifiant le développement backend pour une large gamme d'applications web et mobiles."
    },
    {
      "growth": 0.88,
      "volume": 127.79599999999999,
      "skill": "Glide",
      "display_name": "Glide",
      "part": 0.024103274121491713,
      "category": "nocode",
      "en": "Glide is a free software tool designed for building applications. It simplifies the process of creating functional applications, particularly within the no-code/low-code development space, enabling faster deployment and iteration of software solutions.",
      "fr": "Glide est un outil logiciel gratuit conçu pour la création d'applications. Il simplifie le processus de création d'applications fonctionnelles, en particulier dans l'espace de développement no-code/low-code, permettant un déploiement et une itération plus rapides des solutions logicielles."
    },
    {
      "growth": 0.76,
      "volume": 121.109,
      "skill": "Zapier",
      "display_name": "Zapier",
      "part": 0.022842056289553193,
      "category": "nocode",
      "en": "Zapier is a US-based software company founded in 2011. It offers a web-based service that allows users to connect different web applications and automate workflows without coding. Its major characteristic is enabling seamless integration and task automation between thousands of apps.",
      "fr": "Zapier est une société de logiciels basée aux États-Unis, fondée en 2011. Elle propose un service web qui permet aux utilisateurs de connecter différentes applications web et d'automatiser des workflows sans codage. Sa caractéristique principale est de permettre une intégration transparente et une automatisation des tâches entre des milliers d'applications."
    },
    {
      "growth": 1.76,
      "volume": 120.366,
      "skill": "FileMaker",
      "display_name": "FileMaker",
      "part": 0.022701920974893357,
      "category": "nocode",
      "en": "FileMaker is a cross-platform relational database application developed by Claris International Inc. (formerly part of Apple). It allows users to create custom applications for managing information, automating tasks, and integrating with other software. Its key characteristic is its user-friendly interface combined with powerful database capabilities, making it accessible for business solutions.",
      "fr": "FileMaker est une application de base de données relationnelle multiplateforme développée par Claris International Inc. (anciennement partie d'Apple). Elle permet aux utilisateurs de créer des applications personnalisées pour gérer des informations, automatiser des tâches et s'intégrer à d'autres logiciels. Sa caractéristique clé est son interface conviviale combinée à de puissantes capacités de base de données, la rendant accessible pour des solutions d'entreprise."
    },
    {
      "growth": 0.62,
      "volume": 79.501,
      "skill": "AppSheet",
      "display_name": "AppSheet",
      "part": 0.014994478668602403,
      "category": "nocode",
      "en": "AppSheet is a no-code application development platform acquired by Google in 2020. It allows users to create mobile and web applications from data sources like spreadsheets and databases without writing any code. Its primary characteristic is enabling rapid application development for business processes with minimal technical expertise.",
      "fr": "AppSheet est une plateforme de développement d'applications no-code acquise par Google en 2020. Elle permet aux utilisateurs de créer des applications mobiles et web à partir de sources de données telles que des feuilles de calcul et des bases de données sans écrire de code. Sa caractéristique principale est de permettre le développement rapide d'applications pour les processus métier avec une expertise technique minimale."
    },
    {
      "growth": 0.5700000000000001,
      "volume": 60.926,
      "skill": "Oracle APEX",
      "display_name": "Oracle APEX",
      "part": 0.011491095802106515,
      "category": "nocode",
      "en": "Oracle APEX is a low-code development platform for building enterprise applications on the Oracle Database. Created by Oracle, it enables developers to rapidly create and deploy modern, responsive web and mobile applications with minimal code, focusing on declarative development and SQL expertise.",
      "fr": "Oracle APEX est une plateforme de développement low-code pour la création d'applications d'entreprise sur l'Oracle Database. Créée par Oracle, elle permet aux développeurs de créer et de déployer rapidement des applications web et mobiles modernes et réactives avec un minimum de code, en se concentrant sur le développement déclaratif et l'expertise SQL."
    },
    {
      "growth": 1.58,
      "volume": 51.267,
      "skill": "Mendix",
      "display_name": "Mendix",
      "part": 0.009669336711528653,
      "category": "nocode",
      "en": "Mendix is a low-code application development platform enabling businesses to build and deploy enterprise applications faster. Created by Mendix in 2005, it focuses on visual modeling and reusable components, allowing for rapid development and iteration with less traditional coding.",
      "fr": "Mendix est une plateforme de développement d'applications low-code permettant aux entreprises de construire et de déployer des applications d'entreprise plus rapidement. Créée par Mendix en 2005, elle se concentre sur la modélisation visuelle et les composants réutilisables, permettant un développement et une itération rapides avec moins de codage traditionnel."
    },
    {
      "growth": 0.52,
      "volume": 49.781,
      "skill": "adalo",
      "display_name": "adalo",
      "part": 0.00938906608220898,
      "category": "nocode",
      "en": "Adalo is a no-code platform that enables users to build and launch custom web and mobile applications without writing any code. Launched in 2018, it's designed for entrepreneurs and designers, allowing for rapid prototyping and full application development through its intuitive drag-and-drop interface and pre-built components.",
      "fr": "Adalo est une plateforme no-code qui permet aux utilisateurs de créer et de lancer des applications web et mobiles personnalisées sans écrire de code. Lancée en 2018, elle est conçue pour les entrepreneurs et les designers, permettant un prototypage rapide et le développement d'applications complètes grâce à son interface intuitive de type drag-and-drop et à ses composants pré-construits."
    },
    {
      "growth": 1.27,
      "volume": 43.094,
      "skill": "OutSystems",
      "display_name": "OutSystems",
      "part": 0.00812784825027046,
      "category": "nocode",
      "en": "OutSystems is a high-performance low-code development platform, enabling businesses to build and deploy enterprise-grade applications rapidly. Founded in 2001, it streamlines the entire application lifecycle, from development to deployment and management, facilitating agile software development for diverse business needs.",
      "fr": "OutSystems est une plateforme de développement low-code haute performance, permettant aux entreprises de construire et déployer rapidement des applications de niveau entreprise. Fondée en 2001, elle rationalise l'ensemble du cycle de vie des applications, du développement au déploiement et à la gestion, facilitant le développement agile de logiciels pour divers besoins métier."
    },
    {
      "growth": 0.91,
      "volume": 36.407,
      "skill": "Voiceflow",
      "display_name": "Voiceflow",
      "part": 0.0068666304183319414,
      "category": "nocode",
      "en": "Voiceflow is a design and development platform for building conversational AI experiences. Launched in 2019, it empowers creators to design, prototype, and launch voice and chat applications across multiple channels, offering a visual interface for complex dialogue flows and integrations.",
      "fr": "Voiceflow est une plateforme de conception et de développement pour la création d'expériences d'IA conversationnelles. Lancée en 2019, elle permet aux créateurs de concevoir, prototyper et lancer des applications vocales et de chat sur plusieurs canaux, offrant une interface visuelle pour des flux de dialogue et des intégrations complexes."
    },
    {
      "growth": 1.54,
      "volume": 23.033,
      "skill": "Boomi",
      "display_name": "Boomi",
      "part": 0.004344194754454901,
      "category": "nocode",
      "en": "Boomi, originally Dell Boomi, is an integration Platform as a Service (iPaaS) created by Michael Dell in 2007. It enables businesses to connect applications, data, and processes across cloud and on-premises environments, facilitating seamless data flow and digital transformation initiatives.",
      "fr": "Boomi, à l'origine Dell Boomi, est une intégration Platform as a Service (iPaaS) créée par Michael Dell en 2007. Elle permet aux entreprises de connecter des applications, des données et des processus dans des environnements cloud et on-premises, facilitant ainsi le flux de données transparent et les initiatives de transformation numérique."
    },
    {
      "growth": 0.33999999999999997,
      "volume": 22.29,
      "skill": "Zoho",
      "display_name": "Zoho",
      "part": 0.004204059439795066,
      "category": "nocode",
      "en": "Zoho Creator is a low-code platform that enables users to build custom database-driven applications using a drag-and-drop interface. Launched by Zoho Corporation, it streamlines business process automation and application development, allowing for rapid deployment without extensive coding expertise.",
      "fr": "Zoho Creator est une plateforme low-code qui permet aux utilisateurs de créer des applications personnalisées basées sur des bases de données à l'aide d'une interface drag-and-drop. Lancée par Zoho Corporation, elle rationalise l'automatisation des processus métier et le développement d'applications, permettant un déploiement rapide sans expertise approfondie en codage."
    },
    {
      "growth": 0.6599999999999999,
      "volume": 17.089,
      "skill": "Squarespace",
      "display_name": "Squarespace",
      "part": 0.0032231122371762177,
      "category": "nocode",
      "en": "Squarespace is a proprietary, hosted website building and publishing platform created by Anthony Casalena in 2003. It allows users to create and manage websites, online stores, and portfolios through an easy-to-use interface, offering a range of customizable templates and integrated tools for content creation and e-commerce.",
      "fr": "Squarespace est une plateforme propriétaire d'hébergement et de création de sites web, créée par Anthony Casalena en 2003. Elle permet aux utilisateurs de créer et de gérer des sites web, des boutiques en ligne et des portfolios grâce à une interface facile à utiliser, offrant une gamme de templates personnalisables et d'outils intégrés pour la création de contenu et l'e-commerce."
    },
    {
      "growth": 0.9,
      "volume": 6.687,
      "skill": "GeneXus",
      "display_name": "GeneXus",
      "part": 0.0012612178319385198,
      "category": "nocode",
      "en": "GeneXus is a cross-platform, knowledge-based development tool created by GeneXus. It enables the creation of native applications for web, mobile, and enterprise platforms from a single source, emphasizing rapid application development and code generation for diverse business needs.",
      "fr": "GeneXus est un outil de développement cross-platform, knowledge-based créé par GeneXus. Il permet la création d'applications natives pour les plateformes web, mobiles et d'entreprise à partir d'une source unique, en mettant l'accent sur le rapid application development et la génération de code pour divers besoins métier."
    },
    {
      "growth": 1.97,
      "volume": 6.687,
      "skill": "Nintex",
      "display_name": "Nintex",
      "part": 0.0012612178319385198,
      "category": "nocode",
      "en": "Nintex is a workflow automation software platform. It enables businesses to design, automate, and optimize a wide range of business processes, such as document management and approvals, across various applications and systems without extensive coding.",
      "fr": "Nintex est une plateforme logicielle d'automatisation des flux de travail. Elle permet aux entreprises de concevoir, d'automatiser et d'optimiser un large éventail de processus métier, tels que la gestion et les approbations de documents, sur diverses applications et systèmes sans codage extensif."
    },
    {
      "growth": 1.46,
      "volume": 2.972,
      "skill": "Salesforce Flow",
      "display_name": "Salesforce Flow",
      "part": 0.0005605412586393422,
      "category": "nocode",
      "en": "Salesforce Flow is a declarative automation tool within the Salesforce platform. It enables users to build complex business processes and workflows without extensive coding. Launched by Salesforce, it streamlines tasks across various applications, enhancing user productivity and operational efficiency.",
      "fr": "Salesforce Flow est un outil d'automatisation déclarative au sein de la plateforme Salesforce. Il permet aux utilisateurs de construire des processus métier et des workflows complexes sans codage approfondi. Lancé par Salesforce, il rationalise les tâches dans diverses applications, améliorant la productivité des utilisateurs et l'efficacité opérationnelle."
    },
    {
      "growth": 0.88,
      "volume": 2.972,
      "skill": "SAP S/4HANA",
      "display_name": "SAP S/4HANA",
      "part": 0.0005605412586393422,
      "category": "nocode",
      "en": "SAP S/4HANA is an enterprise resource planning (ERP) business software suite developed by SAP. Launched in 2015, it is designed to run in-memory on SAP's HANA platform. Its key characteristic is enabling real-time processing and analytics, streamlining business operations across finance, logistics, and more.",
      "fr": "SAP S/4HANA est une suite logicielle d'entreprise de planification des ressources d'entreprise (ERP) développée par SAP. Lancé en 2015, il est conçu pour fonctionner en mémoire sur la plateforme HANA de SAP. Sa caractéristique clé est de permettre le traitement et l'analyse en temps réel, rationalisant les opérations commerciales dans la finance, la logistique et plus encore."
    }
  ]
}